import { Form, Input, Modal, Select, Spin, Tag } from 'antd';
import 'moment/locale/es';
import { useState } from 'react';
import { useAuth } from '../../../../../../store/AuthContext/AuthContext';
import { authFetch } from '../../../../../../common/request/authFetch';
import { DrawerPanelTitle, modalPanelStyles } from '../../../../common/Drawers/DrawerPanelTitle';

const defaultCriteria = (categoryName: string) => {
	const trimmedName = categoryName?.trim() || '';
	return trimmedName ? `Nombre o características de ${trimmedName}` : '';
};

const buildLabelCriteria = (criteria: string, examples: string[]) => {
	const base = criteria?.trim() || 'Nombre o características de la categoría';
	const cleanExamples = (examples || [])
		.map((e) => e.trim())
		.filter(Boolean);

	if (cleanExamples.length === 0) {
		return base;
	}

	return `${base}. Ejemplos: ${cleanExamples.join(', ')}`;
};

export const NewCategoryModal = (props: {onFinish: any, onClose: any}) => {
	
	const [form] = Form.useForm();
	const [isLoading, setIsLoading] = useState(false);	
	const [updateData, setUpdateData] = useState(false);
	const [examples, setExamples] = useState<string[]>([]);
	const [criteriaEdited, setCriteriaEdited] = useState(false);
	const { projectGroup } = useAuth();

	const onFormFinish = async (values: any) => {
		setIsLoading(true);
		const data = {
			name: values.name?.trim(),
			labelCriteria: buildLabelCriteria(values.labelCriteria, examples),
			scope: 'GROUP'
		};

		await authFetch(`${process.env.REACT_APP_API}/projects/` + projectGroup.project + '/' + projectGroup.group + '/category', { method: 'POST', data })
			.then(() => { setUpdateData(!updateData) })
			.finally(() => { setIsLoading(false); });
		props.onFinish();
	}

	const resetLocalState = () => {
		setExamples([]);
		setCriteriaEdited(false);
	};
	
	return (
		<Modal
			open={true}
			onOk={() => form.submit()}
			onCancel={props.onClose}
			afterClose={() => {
				form.resetFields();
				resetLocalState();
			}}
			okText="Crear categoría"
			cancelText="Cancelar"
			{...modalPanelStyles}
			title={<DrawerPanelTitle title="Nueva categoría" />}
		>
			<div style={{
				color: '#64748b',
				fontSize: 13,
				lineHeight: 1.45,
				marginBottom: 18,
			}}>
				Define el nombre de la categoría y el criterio de etiquetado. Opcionalmente añade ejemplos de etiquetas para orientar a la IA.
			</div>

			<Form layout='vertical' form={form} onFinish={onFormFinish}>
				<Form.Item
					rules={[{ required: true, message: 'El nombre es obligatorio' }]}
					name="name"
					label="Nombre de la categoría"
					extra={<span style={{ color: '#94a3b8', fontSize: 12 }}>Ejemplos: Servicio, Empleados, Precio…</span>}
				>
					<Input
						placeholder="Ej. Empleados"
						onChange={(e) => {
							if (!criteriaEdited) {
								form.setFieldsValue({
									labelCriteria: defaultCriteria(e.target.value),
								});
							}
						}}
					/>
				</Form.Item>

				<Form.Item
					name="labelCriteria"
					label="Criterio de etiquetado"
					rules={[{ required: true, message: 'El criterio es obligatorio' }]}
					extra={<span style={{ color: '#94a3b8', fontSize: 12 }}>Se rellena automáticamente; puedes editarlo si lo necesitas</span>}
				>
					<Input
						placeholder="Ej. Nombre o características de Empleados"
						onChange={() => setCriteriaEdited(true)}
					/>
				</Form.Item>
				
				<Form.Item
					label="Ejemplos de etiquetas (opcional)"
					extra={<span style={{ color: '#94a3b8', fontSize: 12 }}>Escribe y pulsa Enter para añadir cada ejemplo</span>}
				>
					<Select
						mode="tags"
						value={examples}
						onChange={(values: string[]) => setExamples(values)}
						tokenSeparators={[',']}
						placeholder="Ej. Anna, Naira, Miguel"
						notFoundContent={null}
						style={{ width: '100%' }}
						tagRender={(tagProps) => {
							const { label, closable, onClose } = tagProps;
							return (
								<Tag
									color="blue"
									closable={closable}
									onClose={onClose}
									style={{ marginRight: 3, borderRadius: 6 }}
								>
									{label}
								</Tag>
							);
						}}
					/>
				</Form.Item>
			</Form>

			<div style={{ display: 'flex', justifyContent: 'center' }}>
				<Spin size='large' spinning={isLoading} />
			</div>
		</Modal>
	)
}
